module.exports = __webpack_public_path__ + "static/media/videollamadaInactivo.a0f62021.svg";